const colors = require("../../src/styles/colors");

module.exports = {
    siteTitle: "Chetan Arya's technology blog", // <title>
    shortSiteTitle: "Chetan's Technology blog ", // <title> ending for posts and pages
    siteDescription: "This is the technology blog of Chetan Arya. Here be dragons",
    siteUrl: "https://www.chetanarya.com",
    pathPrefix: "",
    siteImage: "preview.jpeg",
    siteLogo: 'icons/icon-144x144.png',
    siteLanguage: "en",
    resumeKeywords: "Chetan Arya, Resume, Polyglot, Senior Engineering Manager, Technology Leader Full Stack Architect, Big Data Architect, Machine Learning Architect",
    // author
    authorName: "Chetan Arya",
    authorShortName: "Chetan",
    authorTwitterAccount: "chetanarya",
    jobTitle: "Chief Manager/ Chief Architect",
    // info
    infoTitle: "Chetan Arya",
    infoTitleNote: "Chetan's Technology blog",
    // manifest.json
    manifestName: "Chetan's Technology blog",
    manifestShortName: "Chetan Arya", // max 12 characters
    manifestStartUrl: "/",
    manifestBackgroundColor: colors.background,
    manifestThemeColor: colors.background,
    manifestDisplay: "standalone",
    // contact
    contactEmail: "chetan@chetanarya.com",
    facebookId: "",
    // social
    authorSocialLinks: [
        { name: "github", url: "https://github.com/chetanarya" },
        { name: "twitter", url: "https://twitter.com/chetanarya" },
        { name: "facebook", url: "http://facebook.com/chetanarya" }
    ]
};



// WEBPACK FOOTER //
// ./content/meta/config.js